module.exports = __webpack_public_path__ + "static/img/IMG_0907.0548779.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/IMG_0907.jpeg
// module id = yN4P
// module chunks = 0